import React from 'react';
import styled from 'styled-components';
import PaginationFooter from './PaginationFooter';
import Paginator from './Paginator';
import ResultsPerPage from './ResultsPerPage';

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: 100%;
`;

interface IPaginatorProps {
  children?: React.ReactNode;
  total?: number;
  limit?: number;
  offset?: number;
  expandedPagesLimit?: number;
  isLoading?: boolean;
  onPageChange: (q: any) => void;
  standalone?: boolean;
}

const PaginatedList = ({ children, onPageChange, isLoading = false, total = 0, limit = 0, offset = 0, expandedPagesLimit = 7, standalone = true }: IPaginatorProps) => (
  <Layout>
    {children}
    {!isLoading && total !== 0 && (
      <PaginationFooter standalone={standalone}>
        <ResultsPerPage
          pageSize={limit || 0}
          onChange={(value: number) => {
            onPageChange({ limit: value, offset: undefined });
          }}
        />

        <Paginator
          onPageChange={(value: number) => {
            onPageChange({
              limit,
              offset: value * limit,
            });
          }}
          numRecords={total}
          limit={limit}
          offset={offset}
          expandedPagesLimit={expandedPagesLimit}
        />
      </PaginationFooter>
    )}
  </Layout>
);

export default PaginatedList;
